import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleChevronUp.svg",
  "use": "CircleChevronUp.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleChevronUp.svg\"><path d=\"M56,32A24,24,0,1,1,32,8,24,24,0,0,1,56,32ZM30.6025,22.56,19.5981,33.5828a2.0016,2.0016,0,0,0,2.829,2.8324l9.59-9.6064,9.59,9.6064a2.0016,2.0016,0,0,0,2.829-2.8324L33.4316,22.56A1.9984,1.9984,0,0,0,30.6025,22.56Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol